var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCigarette = function SvgCigarette(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 32,
    height: 37,
    viewBox: "0 0 1.04 1.21",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.16;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.4.09c.38-.07.64.24.5.58-.07.16-.2.35-.33.42C.44 1.15.11.81.09.55.06.31.15.14.4.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.54.73c.02.01.41.4.42.4"
  }))));
};

export default SvgCigarette;